import { MobizSettingsValue } from './mobiz-settings-value.do';


/**
 * Base class for all `MobizSettings.value` types.
 *
 * @see: Mobiz.ERP.Settings.DTO.GlobalSettings
 */
export class GlobalSettings extends MobizSettingsValue {
  public PeriodicSyncEnabled: boolean;
  public WhiteListedOrganizationIds: string[];
}
